import { Box, Heading, Body, Container } from '@hover/blueprint';
import React from 'react';
import AboutHoverInvestorsMobile from './AboutHoverInvestorsMobile';
import AboutHoverInvestorsDesktop from './AboutHoverInvestorsDesktop';

const AboutHoverInvestors: React.FC = () => (
  <Box
    shadow="distance300"
    width="100%"
    flexDir={{ base: 'column', desktop: 'row' }}
    justifyContent={{ base: 'flex-start', desktop: 'space-between' }}
    alignItems={{ base: 'center', desktop: 'flex-start' }}
    bg="neutral.0"
    borderRadius="4px"
    pt={{ base: 0, desktop: 500 }}
    pb={{ base: 600, desktop: 0 }}
    px={{ base: 500, desktop: 900 }}
    mt={{ tablet: '80px', desktop: 900 }}
    mb={800}
  >
    <Container
      centerContent
      mt={700}
      maxW={{ base: '100%', tablet: 'xl', desktop: 'sm' }}
      flexDir="column"
      alignItems={{ base: 'center', desktop: 'flex-start' }}
      pl={{ base: 0, desktop: 700 }}
      pr={0}
      mx={0}
    >
      <Heading
        fontWeight={{ base: 600, desktop: 600 }}
        size={{ base: 500, tablet: 600, desktop: 700 }}
        marginBottom={{ base: 500, desktop: 400 }}
      >
        Investors
      </Heading>
      <Body
        fontWeight={{ base: 400, desktop: 400 }}
        size={500}
        textAlign={{ base: 'center', desktop: 'left' }}
        mb={{ base: 500 }}
      >
        Our customers are actually our investors. And we’re proud to work with
        some of the most advanced leaders in the business.
      </Body>
    </Container>
    <AboutHoverInvestorsMobile />
    <AboutHoverInvestorsDesktop />
  </Box>
);

export default AboutHoverInvestors;
